// extracted by mini-css-extract-plugin
module.exports = {"loginBackground":"LoginLayout_loginBackground__3nKOv","footer":"LoginLayout_footer__38epr"};